var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlustracaoSacoDeMoedas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 261,
    viewBox: "0 0 205 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 88.5769,51.0007 72.5005,9.70368 C 89.7794,-2.05137 96.5764,-2.33431 103.656,4.60425 c 5.01,4.91295 6.54,4.99011 13.447,3.82618 10.057,-1.70409 16.565,0.99031 21.947,20.52637 l -24.011,23.4586 z",
    fill: "#66c9d6",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 102.164,66.5562 c 12.022,0 21.768,-5.2542 21.768,-11.7357 0,-6.4815 -9.746,-11.7358 -21.768,-11.7358 -12.0214,0 -21.767,5.2543 -21.767,11.7358 0,6.4815 9.7456,11.7357 21.767,11.7357 z",
    fill: "#69afe1",
    id: "path4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 102.164,71.437 c 12.022,0 21.768,-5.2542 21.768,-11.7357 0,-6.4815 -9.746,-11.7358 -21.768,-11.7358 -12.0214,0 -21.767,5.2543 -21.767,11.7358 0,6.4815 9.7456,11.7357 21.767,11.7357 z",
    fill: "#55a0cd",
    id: "path6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 64.0955,260.251 C 52.2054,260.251 0.0986328,238.651 0.0986328,179.47 0.0986328,120.29 50.6107,81.25 77.1238,62.2477 86.416,55.5793 91.2132,53.753 101.155,53.753 h 2.019 c 9.948,0 14.745,1.8263 24.037,8.4947 26.507,19.0152 77.026,58.0483 77.026,117.2353 0,59.187 -52.088,80.781 -64.004,80.781 z",
    fill: "#66c9d6",
    id: "path8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 89.6443,175.387 89.4,175.226 c -2.4372,-1.569 -6.1991,-3.929 -10.186,-6.43 -4.7008,-2.946 -9.5623,-5.994 -13.1891,-8.328 -5.7489,-3.691 -8.4497,-6.823 -8.4497,-14.559 0,-9.003 8.8741,-16.578 19.3431,-16.578 h 0.0514 c 10.6747,0 19.3367,7.505 19.2916,16.668 0,0.512 0.2033,1.003 0.5651,1.364 0.3618,0.362 0.8525,0.565 1.3641,0.565 0.5117,0 1.0024,-0.203 1.3642,-0.565 0.3617,-0.361 0.5653,-0.852 0.5653,-1.364 0,-10.887 -9.6461,-19.832 -21.7806,-20.494 l 0.0322,-13.369 c 0,-0.512 -0.2033,-1.002 -0.5651,-1.364 -0.3618,-0.362 -0.8524,-0.565 -1.3641,-0.565 -0.5116,0 -1.0023,0.203 -1.3641,0.565 -0.3618,0.362 -0.565,0.852 -0.565,1.364 l -0.0322,13.446 c -11.4657,1.113 -20.7643,9.974 -20.7643,20.314 0,9.376 3.7362,13.633 10.231,17.819 3.6461,2.348 8.5205,5.402 13.2277,8.36 3.9741,2.495 7.7167,4.849 10.1474,6.431 l 0.2508,0.16 c 4.2377,2.721 8.6169,5.537 8.5977,13.961 0,9.151 -8.6942,16.578 -19.3367,16.578 h -0.0579 c -5.0422,0.052 -9.9327,-1.723 -13.7678,-4.996 -1.7145,-1.43 -3.0986,-3.214 -4.0567,-5.23 -0.9581,-2.016 -1.4674,-4.216 -1.4929,-6.448 0,-0.512 -0.2032,-1.003 -0.565,-1.364 -0.3618,-0.362 -0.8525,-0.565 -1.3642,-0.565 -0.5116,0 -1.0023,0.203 -1.3641,0.565 -0.3618,0.361 -0.565,0.852 -0.565,1.364 0.02,2.783 0.6439,5.53 1.8285,8.049 1.1846,2.519 2.9017,4.751 5.0329,6.542 3.8902,3.331 8.7288,5.355 13.8321,5.787 l -0.0322,12.514 c 0,0.512 0.2033,1.002 0.5651,1.364 0.3618,0.362 0.8525,0.565 1.3641,0.565 0.5117,0 1.0024,-0.203 1.3642,-0.565 0.3617,-0.362 0.565,-0.852 0.565,-1.364 l 0.0321,-12.43 c 12.1538,-0.605 21.8641,-9.505 21.8641,-20.391 0,-10.534 -5.9806,-14.399 -10.3727,-17.215 z",
    fill: "#eaf6fa",
    id: "path10"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs17"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 204.138,
    height: 260.251,
    fill: "white",
    transform: "translate(0.0986328)",
    id: "rect14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustracaoSacoDeMoedas);
export default __webpack_public_path__ + "static/media/ilustracao-saco-de-moedas.1e1ad6b4.svg";
export { ForwardRef as ReactComponent };